import React, { useState, useEffect } from 'react'
import UpdateForm from './UpdateForm'
import NewForm from './NewForm'
import { Button, Typography } from '@mui/material'
import { Modal, Accordion } from 'react-bootstrap'

export default function Company() {

  const [lgShow, setLgShow] = useState(false);
  const [createCompanyFlag, setCreateCompanyFlag] = useState(false)

  return (
    <>
      <div className="row">
        <div className="row my-3 ">

          <div className="col-12 col-md-6">
            <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
              Account / {createCompanyFlag ? ('Add') : ('Edit')}
            </Typography>
          </div>

          <div className="col-12 col-md-6 d-flex justify-content-start justify-content-md-end mt-3 mt-md-0">
            <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)}>Help</button>
            <Modal
              size="lg"
              show={lgShow}
              onHide={() => setLgShow(false)}
              aria-labelledby="example-modal-sizes-title-lg">

              <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
                <Modal.Title id="example-modal-sizes-title-lg" >
                  Instructions to Add/Edit Account
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ backgroundColor: '#F8FAFC', padding: '24px' }}>
                <style>{`
                  .help-badge {
                    padding: 4px 10px;
                    border-radius: 16px;
                    font-weight: 700;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-right: 10px;
                  }
                  .badge-create     { background: #e6fffa; color: #234e52; border: 1px solid #b2f5ea; }
                  .badge-update     { background: #fffaf0; color: #9c4221; border: 1px solid #feebc8; }
                  .badge-deactivate { background: #fff5f5; color: #9b2c2c; border: 1px solid #fed7d7; }
                  
                  .help-card-text {
                    font-size: 14px;
                    color: #4a5568;
                    line-height: 1.5;
                    margin-bottom: 16px;
                  }
                  .video-responsive-wrapper {
                    position: relative;
                    width: 100%;
                    padding-top: 56.25%; /* 16:9 Aspect Ratio */
                    border-radius: 8px;
                    overflow: hidden;
                    background: #000000;
                  }
                  .video-responsive-wrapper video {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                  .accordion-button:not(.collapsed) {
                    background-color: #f1f5f9;
                    color: #1e293b;
                  }
                `}</style>

                <Accordion defaultActiveKey="0" flush>

                  {/* 1. CREATE ACCOUNT */}
                  <Accordion.Item eventKey="0" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-create">Create</span>
                      <strong>How to Create a New Account</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Navigate to Account Setup and click on <strong>Create New Account</strong>. Enter the required account details in the provided fields and click the <strong>Submit</strong> button. The new account will be created successfully.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Account - create.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 2. UPDATE ACCOUNT */}
                  <Accordion.Item eventKey="1" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-update">Update</span>
                      <strong>How to View or Edit an Account</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        To view or edit an account, navigate to Account Setup and select the required account name from the dropdown. The account details can be viewed or modified as required, and the changes can be saved by clicking the <strong>Submit</strong> button.
                        <br /><br />
                        <em>Note: The Account ID is non-editable.</em>
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Account - edit.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 3. DEACTIVATE ACCOUNT */}
                  <Accordion.Item eventKey="2" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-deactivate">Deactivate</span>
                      <strong>How to Deactivate an Account</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        To deactivate an account, select the vendor and find the activation toggle (initially disabled). Add or update the comments/notes to enable the toggle, then click to untoggle it. Confirm the pop-up prompt stating <em>"Account deactivated successfully"</em> to finalize the deactivation.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Account - deactivate.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                </Accordion>
              </Modal.Body>
            </Modal>

          </div>
        </div>

        <div className="row">
          <div className="col-12 d-flex justify-content-start justify-content-md-end px-3 px-md-4">
            {createCompanyFlag ?
              (<Button variant="contained" onClick={() => setCreateCompanyFlag(false)} >Edit Account</Button>) :
              (<Button variant="contained" onClick={() => setCreateCompanyFlag(true)} >+ New Account</Button>)
            }
          </div>
        </div>
      </div>

      {createCompanyFlag ? <NewForm /> : <UpdateForm />}
    </>
  )
}
